/**
 * App-wide theme tokens. Import in components, e.g.:
 *   import { PRIMARY } from '../theme';
 *   style={{ background: PRIMARY }}
 */
export const PRIMARY = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
